import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import Database from '../../controllers/Database';
import RecordRowCell from './RecordRowCell';

var RecordRow =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(RecordRow, _React$PureComponent);

  function RecordRow() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, RecordRow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RecordRow)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "rowRef", React.createRef());

    return _this;
  }

  _createClass(RecordRow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          record = _this$props.record,
          database = _this$props.database;
      database.scrollIfNeeded(record.key, this.rowRef.current);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          columns = _this$props2.columns,
          record = _this$props2.record,
          database = _this$props2.database,
          rowIndex = _this$props2.rowIndex;
      return React.createElement("tr", {
        "data-qa": "database-records-row",
        ref: this.rowRef,
        className: "data-hj-suppress"
      }, database.getSortedColumns().map(function (column, columnIndex) {
        var field = record.fields[column.key];
        return React.createElement(RecordRowCell, {
          key: column.key,
          columnIndex: columnIndex,
          rowIndex: rowIndex,
          database: database,
          record: record,
          field: field,
          columns: columns,
          column: column,
          isActive: database.isActive(record.key, column.key),
          isFocused: !!database.isFocused(record.key, column.key),
          isSelected: database.isSelected(record.key, column.key)
        });
      }), !database.readOnly && React.createElement("td", {
        tabIndex: -1,
        className: "slite-editor-database-cell",
        style: {
          minWidth: 28,
          outline: 'none'
        }
      }));
    }
  }]);

  return RecordRow;
}(React.PureComponent);

_defineProperty(RecordRow, "propTypes", {
  database: PropTypes.instanceOf(Database),
  columns: PropTypes.object.isRequired,
  record: PropTypes.object.isRequired,
  rowIndex: PropTypes.number.isRequired
});

export { RecordRow as default };